export default __webpack_public_path__ + "static/1-4e64c9924e86c1b04841b7b86d8a799b.jpeg";